/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

const HOURS = { Sat: [9, 17], Sun: [9, 17], Mon: [9, 17], Tue: [9, 17], Wed: [9, 17], Thu: [9, 13] }

export const OFFICE_NOTE = 'ساعت‌های کار ما توی سکویا استودیو شنبه تا چهارشنبه از ۹ صبح تا ۵ بعدازظهر و پنج‌شنبه از ۹ صبح تا ۱ بعدازظهره. شماره رو سیو کن و توی ساعتای کاری باهامون تماس بگیر.'

export function isOfficeOpen(now) {
  try {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Tehran', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(now || new Date())
    const day = parts.find((p) => p.type === 'weekday')?.value || ''
    const hour = Number(parts.find((p) => p.type === 'hour')?.value) % 24
    const span = HOURS[day]
    return Boolean(span) && Number.isFinite(hour) && hour >= span[0] && hour < span[1]
  } catch (err) {
    return true
  }
}

export function guardCall(e) {
  if (isOfficeOpen()) return
  e.preventDefault()
  window.dispatchEvent(new Event('seq-call-closed'))
}
